// 科技创新成果申报、科技示范申报

export default {
  api: [
    {
      name: "declareStatus",
      method: "GET",
      desc: "获取申报状态",
      path: "/dropdown/declareStatus"
    },
    {
      name: "awards",
      method: "GET",
      desc: "获取是否获奖信息",
      path: "/dropdown/awards"
    },
    {
      name: "status",
      method: "GET",
      desc: "页签状态列表",
      path: "/page/status"
    },
    {
      name: "configQuery",
      method: "GET",
      desc: "申报配置查询",
      path: "/config/query"
    },
    {
      name: "configUpdate",
      method: "POST",
      desc: "申报配置更新",
      path: "/config/update"
    },
    {
      name: "reasonUpdate",
      method: "POST",
      desc: "编辑原因",
      path: "/auth/update"
    },
    {
      name: "audit",
      method: "PUT",
      desc: "批量初审",
      path: "/batch/audit"
    },
    {
      name: "download",
      method: "GET",
      desc: "下载附件",
      path: "/pack/download"
    },
    {
      name: "issue",
      method: "PUT",
      desc: "待发证",
      path: "/issue"
    },
    {
      name: "applyAudit",
      method: "POST",
      desc: "退出请求审核",
      path: "/apply/audit"
    },
    {
      name: "batchDownload",
      method: "POST",
      desc: "批量下载附件",
      path: "/batch/download"
    },
    {
      name: "groupCount",
      method: "GET",
      desc: "通过分组名称统计分组记录数",
      path: "/group/count"
    },
    // 申报配置
    {
      name: "year",
      method: "GET",
      desc: "申报年份下拉框-v1.3",
      path: "/config/year"
    },
    {
      name: "list",
      method: "GET",
      desc: "申报配置列表-v1.3",
      path: "/config/list"
    },
    {
      name: "delete",
      method: "GET",
      desc: "删除申报配置-v1.3",
      path: "/config/delete"
    },
    {
      name: "enable",
      method: "POST",
      desc: "启用/关闭申报配置-v1.3",
      path: "/config/enable"
    },
    {
      name: "query",
      method: "GET",
      desc: "申报配置详情-v1.3",
      path: "/config/query"
    },
    {
      name: "update",
      method: "POST",
      desc: "申报配置新增/更新-v1.3",
      path: "/config/update"
    },
    {
      name: "dictYear",
      method: "GET",
      desc: "年度字典",
      path: "/config/years"
    },
    {
      name: "checkTime",
      method: "GET",
      desc: "根据申报类型获取列表头部信息",
      path: "/config/current"
    },
    {
      name: "selectActivityTimeList",
      method: "GET",
      desc: "根据申报类型获取批次申报活动时间",
      path: "/config/selectActivityTimeList"
    },
    {
      name: "waitCert",
      method: "PUT",
      desc: "批量待发证-（v1.3第二批次）",
      path: "/batch/waitCert"
    }
  ],
  BASE_URL: "/psm/common"
};



// WEBPACK FOOTER //
// ./src/api/psm/common.js